<template>
  <v-container>
    <template v-if="!viewDataIsLoaded">
      <v-skeleton-loader
        type="card-heading, list-item-three-line"
      ></v-skeleton-loader>
    </template>
    <template v-else>
      <!--app-view-toolbar-->
      <app-view-toolbar :title="companyName" :buttons="toolbarButtons" @onButton="onToolbarButton">
      </app-view-toolbar>
      <v-alert
        v-if="isGreen"
        type="info"
      >
        <div class="title">Välkommen till Chaffis!</div>
        Nu är det bara att sätta igång och lägga upp ert första jobb
        <br>
        <v-btn
          class="mt-4"
          @click="addNewAssignment()"
        >
          Sätt igång
        </v-btn>
      </v-alert>
      <template
        v-else
      >
        <!--assignments-->
        <div class="d-flex justify-space-between align-center border-bottom">
          <div class="text-h6">Jobb</div>
          <div>
            <v-btn
              color="secondary"
              small
              text
              class="mt-3 mb-2 ml-2"
              @click="addNewAssignment()"
            >
              <v-icon left>mdi-plus</v-icon>
              Lägg till
            </v-btn>
          </div>
        </div>
        <v-tabs
          color="accent"
          center-active
          show-arrows
        >
          <v-tab
            v-for="assignmentListData of viewData.assignmentListData_ar"
            :key="assignmentListData.label"
            :to="'#' + assignmentListData.label"
          >
            <v-badge
              :content="assignmentListData.listData.item_ar.length.toString()"
              color="accent"
              :value="assignmentListData.useBadge"
              :inline="true"
            >
              {{ assignmentListData.title }}
            </v-badge>
          </v-tab>
          <v-tab-item
            v-for="(assignmentListData, index) of viewData.assignmentListData_ar"
            :key="assignmentListData.label"
            :value="assignmentListData.label"
          >
            <v-container fluid class="pa-0">
              <v-text-field
                v-model="search[index]"
                prepend-icon="mdi-magnify"
                label="Sök"
                single-line
                hide-details
                clearable
                color="secondary"
              ></v-text-field>
              <v-data-table
                :headers="assignmentListData.listData.header_ar"
                :items="assignmentListData.listData.item_ar"
                :items-per-page="assignmentListData.itemsPerPage"
                :hide-default-header="assignmentListData.listData.item_ar.length == 0"
                :hide-default-footer="assignmentListData.listData.item_ar.length == 0"
                :search="search[index]"
              >
                <!--matchedCount-->
                <template v-slot:[`item.matchedCount`]="{ item }">
                  <v-tooltip left>
                    <template v-slot:activator="{ on }">
                      <v-progress-circular
                        v-show="item.unmatched"
                        v-on="on"
                        indeterminate
                        color="secondary"
                        size="25"
                        width="3"
                      ></v-progress-circular>
                      <v-chip
                        v-on="on"
                        v-show="!item.unmatched"
                        dark
                        @click="showMatchedDrivers(item)"
                      >
                        {{ item.matchedCount }}
                      </v-chip>
                    </template>
                    <span v-show="item.unmatched">Matching pågår</span>
                    <span v-show="!item.unmatched && item.matchedCount == 0">Inga chaufförer matchar</span>
                    <span v-show="!item.unmatched && item.matchedCount != 0">Lista matchade chaufförer</span>
                  </v-tooltip>
                </template>
                <!--signedCount-->
                <template
                  v-slot:[`item.signedCount`]="{ item }"
                >
                  <v-tooltip
                    left
                    color="accent"
                  >
                    <template v-slot:activator="{ on }">
                      <v-chip
                        v-on="on"
                        v-show="item.unmatched === 0"
                        dark
                        :color="item.signedCount != 0 ? 'accent' : 'none'"
                        @click="showSignedDrivers(item)"
                      >
                        {{ item.signedCount }}
                      </v-chip>
                    </template>
                    <span v-show="item.signedCount == 0">Inga chaufförer har signerat</span>
                    <span v-show="item.signedCount != 0">Lista signerade chaufförer</span>
                  </v-tooltip>
                </template>
                <!--(assignment name)-->
                <template
                  v-slot:[`item.name`]="{ item }"
                >
                  <!--
                  <v-chip
                    dark
                    color="secondary"
                    @click="showAssignment(item)"
                    label
                  >
                    {{ item.name }}
                  </v-chip>
                  -->
                  <div
                    v-on="on"
                    class="xLink"
                    @click="showAssignment(item)"
                  >
                    {{ item.name }}
                  </div>
                </template>
                <!--driverName-->
                <template
                  v-slot:[`item.driverName`]="{ item }"
                >
                  <!--
                  <v-chip
                    dark
                    label
                    color="secondary"
                    @click="showDriver(item)"
                  >
                    {{ item.driverName }}
                  </v-chip>
                  -->
                  <div
                    v-on="on"
                    class="xLink"
                    @click="showDriver(item)"
                  >
                    {{ item.driverName }}
                  </div>
                </template>
                <!--companyUnassigned_actions-->
                <template v-slot:[`item.companyUnassigned_actions`]="{ item }">
                  <div style="white-space:nowrap;">
                    <v-tooltip
                      left
                      color="secondary"
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn
                          v-on="on"
                          color="secondary"
                          fab
                          x-small
                          dark
                          v-if="item.signedCount == 0"
                          @click="editAssignment(item)"
                          class="mr-2"
                        >
                          <v-icon
                            dark
                            small
                          >
                            mdi-pencil
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>Redigera</span>
                    </v-tooltip>
                    <v-tooltip
                      left
                      color="secondary"
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn
                          v-on="on"
                          color="secondary"
                          fab
                          x-small
                          dark
                          @click="setAssignment(item, 'archivate')"
                        >
                          <v-icon
                            dark
                            small
                          >
                            mdi-eye-off-outline
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>Arkivera</span>
                    </v-tooltip>
                  </div>
                </template>
                <!--companyAssigned_actions-->
                <template v-slot:[`item.companyAssigned_actions`]="{ item }">
                  <v-tooltip
                    left
                    color="secondary"
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn
                        v-on="on"
                        color="secondary"
                        fab
                        x-small
                        dark
                        @click="setAssignment(item, 'archivate')"
                      >
                        <v-icon
                          dark
                          small
                        >
                          mdi-eye-off-outline
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>Arkivera</span>
                  </v-tooltip>
                </template>
                <!--companyArchived_actions-->
                <template v-slot:[`item.companyArchived_actions`]="{ item }">
                  <v-tooltip
                    left
                    color="secondary"
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn
                        v-on="on"
                        color="secondary"
                        fab
                        x-small
                        dark
                        @click="setAssignment(item, 'unarchivate')"
                      >
                        <v-icon
                          dark
                          small
                        >
                          mdi-eye-outline
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>Återta från arkiv</span>
                  </v-tooltip>
                </template>
                <template v-slot:no-data>
                  <div class="text-left">
                    {{ txtNoTableData }}
                  </div>
                </template>
              </v-data-table>
            </v-container>
          </v-tab-item>
        </v-tabs>
      </template>
    </template>
    <!--snack-bar-->
    <app-snack-bar></app-snack-bar>
  </v-container>
</template>

<script>
import axios from 'axios'
import SnackBar from '../components/SnackBar'
import ViewToolbar from '../components/ViewToolbar'
import { generalMixin } from '../mixins/general'
import { urlMixin } from '../mixins/url'
import { snackBarBus } from '../main'
import { mapGetters } from 'vuex'

export default {
  name: 'Assignment',
  components: {
    'app-snack-bar': SnackBar,
    'app-view-toolbar': ViewToolbar
  },
  mixins: [generalMixin, urlMixin],
  data() {
    return {
      on: null,
      refreshTimeout: null,
      viewDataIsLoaded: false,
      viewData: {},
      search: [],
      toolbarButtons: [
        {
          label: 'qualificationPreset',
          icon: 'card-account-details-outline',
          title: 'Administrera chaufförsprofiler'
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['access_token', 'loggedInData', 'isGreen', 'version']),
    companyName() {
      return this.loggedInData.agentData.name
    },
    txtNoTableData() {
      return this.viewDataIsLoaded ? 'Inga finns' : 'Hämtar data...'
    }
  },
  methods: {
    showAssignment(value) {
      this.$router.push({ name: 'assignment', params: { uuid: value.uuid } })
    },
    editAssignment(item) {
      this.$router.push({ name: 'assignment-edit', params: { id: item.id } })
    },
    addNewAssignment() {
      this.$router.push({ name: 'assignment-edit', params: { id: 0 } })
    },
    goToQualificationPreset() {
      this.$router.push({ name: 'qualification-preset' })
    },
    onToolbarButton(button) {
      switch (button.label) {
        case 'qualificationPreset':
          this.goToQualificationPreset()
          break
      }
    },
    doOnViewData(returnData) {
      this.viewData = returnData
      console.log('doOnViewData', returnData)
      let unmatchedCount = 0
      for (let assignmentListData of this.viewData.assignmentListData_ar) {
        if (assignmentListData.label == 'unassigned') {
          for (let item of assignmentListData.listData.item_ar) {
            if (item.unmatched) {
              unmatchedCount++
            }
          }
        }
      }
//      console.log('unmatchedCount', unmatchedCount)
      if (unmatchedCount > 0) {
        //reload data due to pending matching
        this.refreshTimeout = setTimeout(this.loadViewData, 5000)
      }
      this.viewDataIsLoaded = true
      this.checkVersion()
    },
    loadViewData() {
      let config = {
        headers: {
          'Authorization': this.access_token
        }
      }
      let url = this.url_composeApiUrl('/company/dashboard/' + this.loggedInData.agentData.id)
//      console.log('dashboard get', url)
      axios.get(url, config)
        .then(response => {
//          console.log('dashboard response', response)
          if (response.data.success) {
            //success
            this.doOnViewData(response.data.returnData)
          } else if (this.onNonSuccessApiCall(response.data.returnData)) {
            snackBarBus.$emit('message', this.generalParseErrorArray(response.data.returnData.error_ar))
          }
        })
        .catch(error => {
          snackBarBus.$emit('message', error.toString())
        })
    },
    checkVersion() {
      let config = {
        headers: {
          'Authorization': this.access_token
        }
      }
      let postData = {
        version: this.version
      }
      let url = this.url_composeApiUrl('/common/check-version')
//      console.log('check-version', url)
      axios.post(url, postData, config)
        .then(response => {
//          console.log('check-version', response)
          if (response.data.success) {
            //success
            this.doOnCheckVersion(response.data.returnData)
          } else if (this.onNonSuccessApiCall(response.data.returnData)) {
            snackBarBus.$emit('message', this.generalParseErrorArray(response.data.returnData.error_ar))
          }
        })
        .catch(error => {
          snackBarBus.$emit('message', error.toString())
        })
    },
    doOnCheckVersion(data) {
      if (data.isOldVersion) {
        //reload due to old version
        window.location.reload()
      }
    },
    setAssignment(item, act) {
      //show loader
      this.loader = true
      //set config for axios request with Authorization header
      let config = {
        headers: {
          'Authorization': this.access_token
        }
      }
      //post data to API
      let postData = {
        id: item.id,
        act: act,
        agentData: this.loggedInData.agentData
      }
//      console.log('post', postData)
      let url = this.url_composeApiUrl('/assignment/set')
      axios.post(url, postData, config)
        .then(response => {
//          console.log('post response', response)
          this.loader = false
          if (response.data.success) {
            //success
            this.doOnViewData(response.data.returnData)
          } else if (this.onNonSuccessApiCall(response.data.returnData)) {
            //still logged in
            this.errorOutput = this.generalParseErrorArray(response.data.returnData.error_ar)
          }
        })
        .catch(error => {
          this.loader = false
          snackBarBus.$emit('message', error.toString())
        })
    },
    showMatchedDrivers(item) {
      if (!item.unmatched && item.matchedCount > 0) {
        this.$router.push({ name: 'matched-drivers', params: { id: item.id } })
      }
    },
    showSignedDrivers(item) {
      if (item.signedCount > 0) {
        this.$router.push({ name: 'signed-drivers', params: { id: item.id } })
      }
    },
    showDriver(item) {
//      console.log('showDriver', item)
      //open driver by its uuid and also send the uuid for the assignment in order to show assigned data
      this.$router.push({ name: 'driver', params: { uuid: item.drvUuid }, query: { asgUuid: item.uuid } })
    },
    showTab(hash) {
      console.log(hash)
    }
  },
  created() {
    //get viewData
    this.loadViewData()
  },
  destroyed() {
    this.trace('CompanyDashboard destroyed')
    if (this.refreshTimeout) {
      clearTimeout(this.refreshTimeout)
      this.trace('refreshTimeout cleared')
    }
  }
}
</script>

<style>
</style>